import React from 'react';
import { Form, Input, Card, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const VsphereEnvironmentCard = ({ vmLevelEnabled }) => {
    return (
        <Card title="Source vSphere Environment" size="small" className="vm-config-card">
            <Form.Item
                label={
                    <span>
                        vCenter URL{' '}
                        <Tooltip title="Format: https://< ip_address > [:< port_number >]">
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </span>
                }
                name="vcenterUrl"
                rules={[
                    { required: vmLevelEnabled, message: 'Please enter vCenter URL' },
                    { type: 'url', message: 'Please enter a valid URL' },
                ]}
            >
                <Input placeholder="Enter vCenter URL using IP Address (required)" />
            </Form.Item>

            <Form.Item
                label="Username"
                autoComplete="off"
                name="vcenterUsername"
                rules={[{ required: vmLevelEnabled, message: 'Please enter username' }]}
            >
                <Input placeholder="Enter username or identity (required)" />
            </Form.Item>

            <Form.Item
                label="Password"
                autoComplete="off"
                name="vcenterPassword"
                rules={[{ required: vmLevelEnabled, message: 'Please enter password' }]}
                className="vsphere-environment-card__password"
            >
                <Input.Password placeholder="Enter password or secret key (required)" />
            </Form.Item>
        </Card>
    );
};

